<template>
    <InformeCard title="Venta diaria">
        <GChart
            type="LineChart"
            :data="valores"
            :options="chartOptions"
        />
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";

export default {
    props: ['valores'],
    data() {
        return {
            chartOptions: {
                height: 364,
                chartArea:{width:'100%'}
            }
        }
    },
    components: {
        InformeCard,
    }
}
</script>

<style>

</style>
